import React from "react";
import styled from "styled-components";
import { I18n } from "@lingui/react";
import { DataGridHeading, Main, Badge } from "@conserveit/blocks";
import { analysisColumns } from "../../../../utils/columns";
import SortArrow from "../../../SortArrow";
import { GroupHeaderProps as Props } from "../../utils";
import { useState as useAnalysisState } from "../../../../context/analysis";

const StyledHeading = styled(DataGridHeading)`
  white-space: nowrap;
`;

const PriorityGroupHeader: React.FunctionComponent<Props> = ({
  activeSort,
  hitCount,
  equipCount,
  groupCount,
  sortDirection,
  onSort,
}) => {
  const { viewMode } = useAnalysisState();
  const cols = analysisColumns[viewMode];

  return (
    <I18n>
      {({ i18n }) => (
        <React.Fragment>
          <StyledHeading
            minWidth={cols.LATEST.minWidth}
            onClick={() => onSort(cols.LATEST.key)}
          >
            <Main>
              {cols.LATEST.label(i18n)}
              {activeSort === cols.LATEST.key && (
                <SortArrow direction={sortDirection} />
              )}
            </Main>
          </StyledHeading>
          <StyledHeading
            minWidth={cols.PRIORITY.minWidth}
            onClick={() => onSort(cols.PRIORITY.key)}
          >
            <Main>
              {cols.PRIORITY.label(i18n)}
              {activeSort === cols.PRIORITY.key && (
                <SortArrow direction={sortDirection} />
              )}
            </Main>
          </StyledHeading>
          <StyledHeading
            minWidth={cols.SITE.minWidth}
            onClick={() => onSort(cols.SITE.key)}
          >
            <Main>
              {cols.SITE.label(i18n)} <Badge>{groupCount}</Badge>
              {activeSort === cols.SITE.key && (
                <SortArrow direction={sortDirection} />
              )}
            </Main>
          </StyledHeading>
          <StyledHeading
            minWidth={cols.REGION.minWidth}
            onClick={() => onSort(cols.REGION.key)}
          >
            <Main>
              {cols.REGION.label(i18n)}
              {activeSort === cols.REGION.key && (
                <SortArrow direction={sortDirection} />
              )}
            </Main>
          </StyledHeading>
          <StyledHeading
            minWidth={cols.SEVERITY.minWidth}
            onClick={() => onSort(cols.SEVERITY.key)}
          >
            <Main>
              {cols.SEVERITY.label(i18n)}
              {activeSort === cols.SEVERITY.key && (
                <SortArrow direction={sortDirection} />
              )}
            </Main>
          </StyledHeading>
          <StyledHeading
            minWidth={cols.RULE_NAME.minWidth}
            onClick={() => onSort(cols.RULE_NAME.key)}
          >
            <Main>
              {cols.RULE_NAME.label(i18n)}
              {activeSort === cols.RULE_NAME.key && (
                <SortArrow direction={sortDirection} />
              )}
            </Main>
          </StyledHeading>
          <StyledHeading
            minWidth={cols.RULE_TYPE.minWidth}
            onClick={() => onSort(cols.RULE_TYPE.key)}
          >
            <Main>
              {cols.RULE_TYPE.label(i18n)}
              {activeSort === cols.RULE_TYPE.key && (
                <SortArrow direction={sortDirection} />
              )}
            </Main>
          </StyledHeading>
          <StyledHeading
            minWidth={cols.AFFECTED_EQUIPS.minWidth}
            onClick={() => onSort(cols.AFFECTED_EQUIPS.key)}
          >
            <Main>
              {cols.AFFECTED_EQUIPS.label(i18n)} <Badge>{equipCount}</Badge>
              {activeSort === cols.AFFECTED_EQUIPS.key && (
                <SortArrow direction={sortDirection} />
              )}
            </Main>
          </StyledHeading>
          <StyledHeading
            minWidth={cols.TRIGGERED_RULES.minWidth}
            onClick={() => onSort(cols.TRIGGERED_RULES.key)}
          >
            <Main>
              {cols.TRIGGERED_RULES.label(i18n)} <Badge>{hitCount}</Badge>
              {activeSort === cols.TRIGGERED_RULES.key && (
                <SortArrow direction={sortDirection} />
              )}
            </Main>
          </StyledHeading>
        </React.Fragment>
      )}
    </I18n>
  );
};

export default PriorityGroupHeader;
